import { QueryKey, UseQueryOptions, useQuery } from "@tanstack/react-query";
import instance from "core/constants/request";
import { SimpleResponseDTO } from "interface";
import { ARTICLE_END_POINTS } from "core/constants/endpoints";
import { articleBanner } from "pages/articles/type";

const getAds = async (
  query: QueryKey
): Promise<SimpleResponseDTO<articleBanner[]>> => {
  const [{ articleId }] = query as QueryType[];

  const res = await instance.get(
    `${ARTICLE_END_POINTS.list_banners}?articleId=${articleId}`
  );

  return res.data;
};

type QueryType = { articleId: number };
type UseGetAdsOptions = UseQueryOptions<
  SimpleResponseDTO<articleBanner[]>,
  QueryType,
  SimpleResponseDTO<articleBanner[]>
>;
export const useGetAds = (config?: UseGetAdsOptions) => {
  return useQuery({
    queryKey: [ARTICLE_END_POINTS.list_banners],
    queryFn: ({ queryKey }) => getAds(queryKey),
    ...config,
  });
};
